import PaymentStatusEnum from '../../types/PaymentStatusEnum';

const paymentStatusMapping: Record<string, PaymentStatusEnum> = {
  cancel: PaymentStatusEnum.NotPaid,
  canceled: PaymentStatusEnum.NotPaid,
  declined: PaymentStatusEnum.NotPaid,
  error: PaymentStatusEnum.NotPaid,
  failed: PaymentStatusEnum.NotPaid,
  'no-payment': PaymentStatusEnum.NotPaid,
  'not-paid': PaymentStatusEnum.NotPaid,
  rejected: PaymentStatusEnum.NotPaid,
  paid: PaymentStatusEnum.Paid,
  succeeded: PaymentStatusEnum.Paid,
  success: PaymentStatusEnum.Paid,
  successful: PaymentStatusEnum.Paid,
  incomplete: PaymentStatusEnum.Pending,
  'payment-processing': PaymentStatusEnum.Pending,
  pending: PaymentStatusEnum.Pending,
  requires_payment_method: PaymentStatusEnum.Pending,
  requires_capture: PaymentStatusEnum.Pending,
  requires_confirmation: PaymentStatusEnum.Pending,
  requires_action: PaymentStatusEnum.Pending,
  processing: PaymentStatusEnum.Pending,
  waiting: PaymentStatusEnum.Pending,
  sent: PaymentStatusEnum.Sent,
  unknown: PaymentStatusEnum.Unknown,
};

const getPaymentStatus = (rawStatus: string) =>
  paymentStatusMapping[rawStatus] || PaymentStatusEnum.Unknown;

export default getPaymentStatus;
